module.exports = __webpack_public_path__ + "static/media/wellness-589773_1280.2cd384a9.jpg";